import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseGems1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.gems;

  const purchaseGems1 = useCallback(
    async (amount, postApiRes, id, balance, min) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      const fixedAmount = Math.round(parseFloat(parseFloat(amount).toFixed(6)) * 1e12) / 1e12;
      const nd = parseEther(fixedAmount.toString());

      let minValue = Math.round(parseFloat((min * 0.99).toFixed(6)) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      console.log("purchaseGems1 params:", nd, minValue, postApiRes.code, id);

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithToken",
          args: [
            UsdtAdress,
            nd,
            postApiRes.code,
            postApiRes?.normalizationFactor,
            postApiRes.referenceTokenPrice,
            minValue,
            id,
            postApiRes.price,
            postApiRes.deadline,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("purchaseGems1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("purchaseGems1 confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("purchaseGems1 error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseGems1 };
};

export default usePurchaseGems1;
